import { v4 as uuid } from "uuid";

export const categories = [
  {
    _id: uuid(),
    categoryName: "All",
    description:
      "All videos"
  },
  
  {
    _id: uuid(),
    categoryName: "Programming",
    description:
      "hitesh choudhary, code with harry, Web devs simplified, fcc"
  },
 
  {
    _id: uuid(),
    categoryName: "Health Awareness",
    description:
      "fit tuber"
  },
  {
    _id: uuid(),
    categoryName: "Social Awareness",
    description:
      "dhruv rathe, LLA"
  },

  {
    _id: uuid(),
    categoryName: "News",
    description:
      "lallantop, bol bhidu"
  },

  {
    _id: uuid(),
    categoryName: "Javascript",
    description:
      "akshay saini"
  }
  
]